import React from 'react';

interface IAddIconProps {
  strokeColor?: string;
}

const ColorStopIcon: React.FC<IAddIconProps> = (props: IAddIconProps) => {
  return (
    <svg width="18" height="21" viewBox="0 0 18 21" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M0.5 4.44152C0.5 3.79587 0.913145 3.22266 1.52566 3.01849L8.52566 0.68516C8.83356 0.582527 9.16644 0.582527 9.47434 0.68516L16.4743 3.01849C17.0869 3.22266 17.5 3.79587 17.5 4.44152V19C17.5 19.8284 16.8284 20.5 16 20.5H2C1.17157 20.5 0.5 19.8284 0.5 19V4.44152Z" stroke={props.strokeColor ?? "#CCCBCB"} stroke-opacity="0.8" />
    </svg>
  )
}

export default ColorStopIcon;